import { IconClose } from 'assets/icons';
import { BookingConnection, TicketState, UnfixedTicket } from 'types/api';
import BookingDetailModalHeader from './BookingDetailModalHeader';
import styled from 'styled-components';
import SellingDetailSection from './SellingDetailSection';
import Loading from 'components/Loading/Loading';
import ListLoadingSpinner from '../components/ListLoadingSpinner';

const ModalContent = styled.div`
  width: 100%;
`;

const LoadingBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  height: 400px;
`;

interface Props {
  isMobile: boolean;
  handleModal: () => void;
  item: UnfixedTicket;
  handleRefetchBookingList: () => void;
  bookingItems: BookingConnection;
  searchedKeyword: string;
  searchKeyword: string;
  keywordHandler: (value: string) => void;
  onSearch: () => void;
  bookingItemsLoading: boolean;
  handleRefetchBookingItemList: () => void;
  handleCancelBookingConfirmModal: () => void;
  saveSelectedConfirmedBookingIds: (
    selectedConfirmedBookingIds: string[],
  ) => void;
}

/* 확정된 일정 보여주는 모달 - 조율형 */
function UnfixedBookingDetailContent({
  isMobile,
  handleModal,
  item,
  handleRefetchBookingList,
  bookingItems,
  searchedKeyword,
  searchKeyword,
  keywordHandler,
  onSearch,
  bookingItemsLoading,
  handleRefetchBookingItemList,
  handleCancelBookingConfirmModal,
  saveSelectedConfirmedBookingIds,
}: Props) {
  const startTime = item.scheduleTerm.startedAt;
  const endTime = item.scheduleTerm.endedAt;

  const totalConfirmedCount = bookingItems?.edges
    ?.map(item =>
      item.node.tickets.filter(ticketItem => {
        if (
          ticketItem.scheduleTerm?.startedAt === startTime &&
          ticketItem.status === TicketState.CONFIRMED
        ) {
          return true;
        }
      }),
    )
    .flat().length;

  return (
    <>
      <BookingDetailModalHeader
        isMobile={isMobile}
        startTime={startTime}
        endTime={endTime}
        item={item}
        handleModal={handleModal}
        handleRefetchBookingList={handleRefetchBookingList}
        ticketType={'unfixed'}
      />

      <ModalContent>
        {bookingItems ? (
          <SellingDetailSection
            bookingItems={bookingItems}
            searchedKeyword={searchedKeyword}
            searchKeyword={searchKeyword}
            keywordHandler={keywordHandler}
            onSearch={onSearch}
            bookingItemsLoading={bookingItemsLoading}
            totalCount={totalConfirmedCount}
            ticketType={'unfixed'}
            handleRefetchBookingItemList={handleRefetchBookingItemList}
            startTime={startTime}
            saveSelectedConfirmedBookingIds={saveSelectedConfirmedBookingIds}
            handleCancelBookingConfirmModal={handleCancelBookingConfirmModal}
            ticketOriginType={'unfixed'}
          />
        ) : (
          <ListLoadingSpinner />
        )}
      </ModalContent>
    </>
  );
}

export default UnfixedBookingDetailContent;
